import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import toast from 'shared/utils/toast';
import MovementReasonsForm from '../components/MovementReasonsForm';
import { IMovementReason } from '../types';
import { movementReasonService } from '../../api/movement-reason.service';

const initMovementReason: IMovementReason = {
  id: null,
  code: null,
  direction: 'IN',
  description: null,
  discounted: false,
  order_independent: false
};

export const AddMovementReason = () => {
  const translationPrefix = 'pages.reason.new';
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const createMovementReason = async (values) => {
    dispatch(loadingActions.startLoading());
    movementReasonService.add(values).then((res) => {
      toast.crud.successCreate('Causale', 'f');
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <MovementReasonsForm movementReason={initMovementReason} onSubmit={createMovementReason} />
    </TenantPage>
  );
};

export default AddMovementReason;
